var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isPlatform)?_c('div',[_c('fdk-accounts',{scopedSlots:_vm._u([{key:"default",fn:function(accountsData){return [_c('div',[_vm._t("default",null,null,accountsData)],2)]}}],null,true)})],1):_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }